import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button } from "@mui/material";
import Login from "./login";
import TermsAndConditions from "./TermsAndConditions";
import VerificationCode from "./VerificationCode";
import { loginRequestCaps } from "../authConfig";
import { useMsal } from "@azure/msal-react";
import gmlogo from './GMEnergy.png';
import './styles.css';
import * as constants from '../utils/constants.ts';

const MainPage = () => {
  const [savedSerialNumber, setSavedSerialNumber] = useState(-1);
  const [showLogin, setShowLogin] = useState(true);
  const [showTerms, setShowTerms] = useState(false);
  const [showVerification, setShowVerification] = useState(false);
  const [token, setToken] = useState(null);
  const [errorOccurred, setErrorOccurred] = useState(false);
  const { instance } = useMsal();
  // const [anchorEl, setAnchorEl] = useState(null);
  const [passcode, setPasscode] = useState("");

  const reacquireToken = () => {
    // console.log('has account');
    const request = {
      scopes: ['openid'],
      account: instance.getAllAccounts()[0],
    };

    instance
      .acquireTokenSilent(request)
      .then((tokenResponse) => {
        console.log(tokenResponse)
        setToken(tokenResponse.idToken)
        setShowLogin(false);
        setShowTerms(true);
      })
      .catch((error) => {
        console.log('error', error);
        // handle other errors
      });
  };

  useEffect(() => {
    instance
      .handleRedirectPromise()
      .then((response) => {
        if (response !== null) {
          console.log('response', response);
          setToken(response.idToken);
          setShowLogin(false);
          setShowTerms(true);
        } else if (instance.getAllAccounts()[0]) {
          reacquireToken();
        } else {
          setShowLogin(true);
          setShowTerms(false);
        }
      })

      .catch((error) => {
        console.log('error', error);
      });
  }, [instance]);


  // useEffect(() => {
  //   instance
  //     .handleRedirectPromise()
  //     .then((response) => {
  //       console.log("response", response);
  //       setToken(response.idToken);
  //       // console.log("token", response.idToken)
  //       if (response !== null) {
  //         setShowLogin(false);
  //         setShowTerms(true);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
  //     });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [instance]);

  // Web username: nrg_energy@gm.com
  // Web password: nrg_energy123

  const setTnCAndSerialNumber = async (sn) => {
    // console.log(token)
    const config = {

      headers: {
        // locale: `en-US`,
        caps_auth: token,
        "Content-Type": "application/json",
      }
    };
    const data = {
      serialNumber: sn,
    };
    console.log(token)
    try {
      const { host } = window.location;
      const getapi = () => {
        switch (true) {
          case host.includes('localhost'):
            return constants.API_ENDPOINT_DEV;
          case host.includes("tst"):
            return constants.API_ENDPOINT_DEV;
          case host.includes("prod"):
            return constants.API_ENDPOINT_PROD;
          default:
            return constants.API_ENDPOINT_DEV;
        }
      };
      const api = getapi();
      const response = await axios.post(
        api,
        data,
        config
      );
      console.log("Serial Number set successfully:", response.data);
      if (response.status === 200) {
        setPasscode("Thank you for registering your product. If you have any questions, please contact 1-833-64POWER.");
        setErrorOccurred(false);
      }
      // const passcode = response.data.Passcode;
      // setPasscode(passcode);
    } catch (error) {
      setErrorOccurred(true);
      console.log("Failed to set Serial Number", error);
      if (error.response?.data?.field === "Token has expired") {
        handleSignOut()
      }
    }
  };

  const handleSignIn = () => {
    instance.loginRedirect(loginRequestCaps);
  };

  const handleSignOut = () => {
    // sessionStorage.removeItem('gmLogin');
    // setAnchorEl(null);
    instance.logoutRedirect({
      // postLogoutRedirectUri: '/logged-out',
      postLogoutRedirectUri: "/",
    });
  };
  const handleLogin = () => {
    // setShowLogin(false);
    // setShowTerms(true);
    handleSignIn();
  };

  // let tncValue = false;
  const handleTermsAccept = (serialNumber) => {
    setShowTerms(false);
    setShowVerification(true);
    // let tncValue = true;
    //send order number
    setTnCAndSerialNumber(serialNumber);
    setSavedSerialNumber(serialNumber);

  };
  const handleRetry = () => {
    setTnCAndSerialNumber(savedSerialNumber);
  };
  // let orderNumberValue = "123456";
  const handleVerification = () => {
    setShowVerification(false);
    // let orderNumberValue = "'654321'";
  };
  // console.log(anchorEl);
  return (
    <Box
      sx={{
        backgroundColor: '#2e2d31',
        minHeight: '100vh',
        position: 'relative',
        overflow: 'auto',
        overflowX: 'hidden',
        // '@media (max-width: 325px)': {
        //   minHeight: '160vh',
        // },
      }}>
      <div className="page-container">
        <div className="pages">
      {showLogin && <Login onLogin={handleLogin} />}
      {showTerms && <TermsAndConditions onAccept={handleTermsAccept} />}
      {showVerification && <VerificationCode onRetry={handleRetry} onSuccess={handleVerification} passcode={passcode} />}
      </div>
      {errorOccurred && showVerification &&
      // <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 'calc(90% - 110px)', zIndex: '10000' }}>
      <div className="retry" style={{maxWidth: '500px'}}>
        <div style={{paddingBottom: '10px', fontSize: '14px', fontWeight: 'normal', color: 'red' }}>An error occurred. Click below to retry</div>
        <div style={{paddingBottom: '20px', fontSize: '14px', fontWeight: 'normal', color: 'red' }}>If you continue to get this error, please call the GM Energy Customer Support Center at <span style={{whiteSpace: 'nowrap'}}>1-833-64POWER</span></div>
        <Button variant="contained" color="primary" size="small" style={{ fontSize: '12px' }} onClick={handleRetry}>Retry</Button>
      </div>
      }
      </div>
      {token && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleSignOut}
          sx={{
            position: 'absolute',
            top: '50px',
            right: '50px',
            zIndex: '1',
            '@media (max-width: 325px)': {
              top: '100px',
              left: '50px',
              width: '125px',
            },
          }}>
          Logout
        </Button>
      )}
      <img 
        src={gmlogo} 
        alt="My Image" 
        style={{
          position: 'absolute',
          top: '45px',
          height: '50px',
          left: '50px',
          zIndex: '0',
          filter: 'brightness(0) invert(1)',
          }} />
    </Box>
  );
};

export default MainPage;
